/* GX Gallery Fix v8 - event-based safety net (sem polling, sem style-observer)
   A reserva de altura agora é feita por CSS no snippet product-page-gallery.liquid
   (aspect-ratio no container). Este JS é só rede de segurança: ajusta a altura a
   partir das dimensões reais das imagens em eventos pontuais (load/resize/troca de slide). */
(function () {
  function fix() {
    var nav = document.querySelector('.productView-nav');
    if (!nav) return;
    var sl = nav.querySelector('.slick-list');
    var tr = nav.querySelector('.slick-track');
    var w = nav.offsetWidth;
    if (!w) return;

    nav.querySelectorAll('.slick-slide img:not(.zoomImg)').forEach(function (img) {
      if (img.naturalWidth && img.naturalHeight) {
        var h = Math.round(w * img.naturalHeight / img.naturalWidth);
        img.style.setProperty('height', h + 'px', 'important');
        img.style.setProperty('width', '100%', 'important');
      }
    });

    var active = nav.querySelector('.slick-slide.slick-active img:not(.zoomImg)');
    if (active && active.naturalWidth) {
      var ah = Math.round(w * active.naturalHeight / active.naturalWidth);
      if (ah > 100 && sl && tr) {
        sl.style.setProperty('height', ah + 'px', 'important');
        tr.style.setProperty('height', ah + 'px', 'important');
      }
    }
  }

  function bind() {
    var nav = document.querySelector('.productView-nav');
    if (!nav) return;

    // Recalcula quando cada imagem termina de carregar (uma vez por imagem).
    nav.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', fix, { once: true });
    });

    // Recalcula ao trocar de slide do Slick.
    try { $(nav).on('afterChange', function () { setTimeout(fix, 30); }); } catch (e) {}

    // Recalcula no resize (debounce).
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(fix, 100);
    });
  }

  function start() { fix(); bind(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Rede de segurança final quando tudo (imagens incluídas) terminou de carregar.
  window.addEventListener('load', fix);
})();
